<template>
  <div class="trustworthiness-box" title="项目公布" v-loading="loading" element-loading-text="拼命加载中">
    <!--查询条件区域类名 -->
    <div class="queryCondition">
      <!--form表单查询区域 -->
      <el-form :rules="rulesFrom" :model="criteria" ref="formdatas">
        <!--折叠效果区域 -->
<!--        <el-collapse accordion value="" @change="collapseChange">-->
<!--          <el-collapse-item name="1">-->
            <!--首行展示区域 -->
<!--            <template slot="title">-->
              <div class="row" @click="stopProp" style="width:98%">
                <el-form-item label="项目负责人" prop="leader">
                    <el-input v-model="criteria.leader" clearable></el-input>
				        </el-form-item>
                <el-form-item label="依托单位" prop="manageUnitName">
                  <el-input v-model="criteria.manageUnitName" clearable></el-input>
                </el-form-item>
                <el-form-item label="批准年度" prop="establishYear">
                  <el-date-picker   type="year"
                                    value-format="yyyy" v-model="criteria.establishYear" clearable></el-date-picker>
                </el-form-item>
              </div>
<!--            </template>-->
            <!--第二行、第三行查询条件区域 查询重置始终保持在最后面 在展开折叠时进行切换-->
            <div class="row" @click="stopProp" style="width:98%">
              <el-form-item label="手机号" prop="smsPhone">
                <el-input v-model="criteria.smsPhone" clearable></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="smsCode">
                <template>
                  <el-input v-model="criteria.smsCode" style="width:100px"></el-input>
                  <el-button
                      type="primary"
                      style="margin-left: 10px"
                      @click="queryphone"
                      v-if="iscode"
                  >获取验证码</el-button
                  >
                  <el-button
                      key="index"
                      v-else
                      type="primary"
                      style="margin-left: 10px"
                      disabled
                  >{{ timer }}秒后重新获取</el-button
                  >
                </template>
              </el-form-item>
                <el-form-item class="ml50">
                  <el-button
                    type="primary"
                    @click="queryListByCriteria"
                    icon="el-icon-search"
                    :loading="loading"
                    >查询</el-button
                  >
                  <el-button
                    type="info"
                    @click="resetQuery"
                    icon="el-icon-refresh"
                    :loading="loading"
                    >重置</el-button
                  >
                </el-form-item>
            </div>
<!--          </el-collapse-item>-->
<!--        </el-collapse>-->
      </el-form>
    </div>
    <!-- table -->
    <div class="tableContent" ref="tableContent">
			<div class="ai-c mb20">
                查询结果
            </div>
			<el-table
				:data="tableData"
				ref="showTable"
				style="width: 100%"
				:header-cell-style="{
					background: '#E1EEFB',
					color: '#000000',
					fontSize: '18px',
					textAlign: 'center'
				}"
				:cell-style="{
					'text-align': 'center',
					padding: '0.5rem 0',
					fontSize: '18px'
				}"
			>
				<el-table-column type="index" label="序号" width="70px"></el-table-column>
        <el-table-column label="批准年度" prop="establishYear" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="项目名称" prop="projectName" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="依托单位" prop="manageUnitName" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="推荐单位" prop="recommendUnitName" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="立项结果" prop="projectEstablishResult" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.projectEstablishResult == 1">立项</span>
            <span v-else-if="scope.row.projectEstablishResult==2">不予立项</span>
            <span v-else>待确认</span>
          </template>
        </el-table-column>
        <el-table-column label="立项编号" prop="projectEstablishNo" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="立项金额" prop="projectEstablishAmount" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="指标文" prop="indexText" :show-overflow-tooltip="true"></el-table-column>
			</el-table>
			<div class="row-r">
				<el-pagination
					background
					layout="total, prev, pager, next, sizes"
					:total="pageTotal"
					:current-page="criteria.page"
					:page-size="criteria.pageSize"
					:page-sizes="[5, 10, 20, 50, 100]"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
	</div>

  </div>
</template>

<script>
import declareProjectService from "../../api/project/declare-project";
export default {
  data() {
    return {
        loading:false,
      headers: {"Content-Type": "multipart/form-data;charset=UTF-8"},//上传的请求头
      isshowbutton:false,//查询、重置按钮显示标志位
      screenHeight: null, //table高度
      dialogVisible:false, //新增弹窗
      lookisible:false,//查看弹窗
      formdata:{}, //查询
      dishonest:false,//失信受理
      dishonestform:{},//失信受理信息
      handle:false,//失信办理
      handleform:{},//失信办理信息
      tableData:[],
        // 页码数
      pageTotal:0,
        //   查询条件
    criteria:{
      page:1,
      pageSize:10,
      smsPhone:'',
      leader:'',
      manageUnitName:'',
      establishYear:'',
      smsCode:'',
    },
    iscode:true,
    timer:60,
      //非空验证
      rulesFrom: {
        leader: [{ required: true, message: "请输入项目负责人名称", trigger: "blur" },],
        smsPhone: [{ required: true, message: "请输入手机号", trigger: "blur" },],
        manageUnitName: [{ required: true, message: "请输入依托单位名称", trigger: "blur" },],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" },],
        establishYear: [{ required: true, message: "请选择批准年度", trigger: "blur" },],
      },
    };
  },
  mounted() {

  },

  methods: {
    // 阻止冒泡
    stopProp(e) {
      e.stopPropagation();
    },
    // 给表格定义高度
    tableheight(height) {
        if(this.tableData.length <= 0){
            this.screenHeight=100
        } else{
            const he = document.body.clientHeight;
            const h = this.$refs.tableContent.getBoundingClientRect().top + 157;
            this.screenHeight = he - h ;
        }

    },
    //折叠效果-控制表格
    collapseChange(e) {
      if (e == 1) {
        this.isshowbutton = !this.isshowbutton;
        setTimeout(() => {
            this.tableheight();
        }, 300);
      } else {
        this.isshowbutton = !this.isshowbutton;
        setTimeout(() => {
            this.tableheight();
        }, 300);
      }
    },
    // 查询
    queryListByCriteria(){
        this.$refs.formdatas.validate(valid => {
        // 点确定新增校验哪些值没传
        if(valid){
            this.loading = true
            declareProjectService.queryProjectAnnouncementList(this.criteria).then(res=>{
                this.tableData = res.data.list
                this.pageTotal= res.data.total
                this.loading = false
            }).catch(res => {
              this.loading = false
              this.$message({
                message: res.response.data.message,
                type: 'warning'
              });
            })
        }
    })
    },
    // 重置
    resetQuery(){
        this.criteria= {}
    },
    // excel批量筛选
    addHandle(){
        this.dialogVisible= true
    },
    //页码变化
    handleCurrentChange(currentPage) {
      this.criteria.page = currentPage;
      this.queryListByCriteria();
    },
    //每页数变化
    handleSizeChange(pageSize) {
      this.criteria.page = 1
      this.criteria.pageSize = pageSize
      this.queryListByCriteria()
    },
    // 发送验证码
    queryphone() {
      if (this.criteria.smsPhone.length != 11 || this.criteria.smsPhone ==  '' ) {
        this.$message({
          message: "请输入正确手机号",
          type: "warning",
        });
      } else {
        declareProjectService.sendQuerySmsCode(this.criteria.smsPhone).then((res) => {
          let timer = 60;
          this.iscode = false;
          this.timeFun = setInterval(() => {
            --timer;
            this.timer = timer;
            if (timer == 0) {
              clearInterval(this.timeFun);
              this.iscode = true;
            }
          }, 1000);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
	display: flex;
	height: 78px;
	flex-wrap: wrap;
	line-height: 32px;
}
.el-collapse {
	border: 0;
}
::v-deep .el-collapse-item__arrow {
	margin: 0;
	margin-top: -23px;
} 
::v-deep .queryCondition .el-form-item__label{
    width: 120px !important;
}
.trustworthiness-box {
    width: 1280px;
    margin: 0 auto;
}
::v-deep .el-select > .el-input{
    width: 190px;
}
::v-deep .el-input{
    width: 190px;
}
::v-deep .el-collapse-item__header{
    position: relative;
}
::v-deep .el-collapse-item__arrow{
    right: 30px;
}
</style>